import { createFileRoute } from '@tanstack/react-router'
import BlogIndexPage from 'pages/blog/index'
import { blogIndex } from 'components/blog/posts'
import {
   blogSchema,
   canonicalLink,
   DEFAULT_OG_IMAGE,
   isoDate,
   ldJsonScript,
   ogCard,
   pageMeta,
   SITE_URL,
} from 'lib/seo'

const BLOG_URL = `${SITE_URL}/blog`
const TITLE = 'Blog — Thai2English'
const DESCRIPTION =
   'Updates to the Thai2English dictionary and translator, plus notes on learning to read Thai.'

// The landing page for /blog. Its title and description are the section's own
// rather than any post's, but the share card is the newest post's — the index
// has no card of its own, and that's the thing a link to /blog is advertising.
export const Route = createFileRoute('/blog/')({
   head: () => {
      const latest = blogIndex[0]
      return {
         meta: pageMeta({
            title: TITLE,
            description: DESCRIPTION,
            url: BLOG_URL,
            image: latest ? ogCard(latest.slug, latest.meta.title) : DEFAULT_OG_IMAGE,
         }),
         links: [canonicalLink(BLOG_URL)],
         scripts: [
            ldJsonScript(
               blogSchema({
                  url: BLOG_URL,
                  name: 'The Thai2English blog',
                  description: DESCRIPTION,
                  posts: blogIndex.map(({ slug, meta }) => ({
                     url: `${SITE_URL}/blog/${slug}`,
                     headline: meta.title,
                     datePublished: isoDate(meta.date),
                     author: meta.author,
                  })),
               })
            ),
         ],
      }
   },
   component: BlogIndexPage,
})
